<template>
<div>
    <b-navbar type="dark" variant="warning" class="px-2">
        <b-navbar-brand href="/"><strong>{{ env.APP_NAME }}</strong></b-navbar-brand>
<!--
        <b-navbar-nav class="mr-auto">
            <b-nav-item to="/">{{ trans.pages['calendar'] }}</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
        <b-nav-item to="/me/inventories">
            <font-awesome-icon icon="inventory" class="fa-fw" />
        </b-nav-item>

        <b-nav-item to="/me/stores">
            <font-awesome-icon icon="store" class="fa-fw" />
        </b-nav-item>
            <template v-if="auth_level >= '200'">
                <b-nav-item-dropdown right>
                    <template v-slot:button-content>
                        <font-awesome-icon icon="cogs" class="fa-fw" />
                    </template>
                    <b-dropdown-item to="/settings/users">{{ trans.pages['settings.users'] }}</b-dropdown-item>
                    <b-dropdown-item to="/settings/calendar">{{ trans.pages['settings.calendar'] }}</b-dropdown-item>
                    <b-dropdown-item to="/settings/html">{{ trans.pages['settings.html'] }}</b-dropdown-item>
                </b-nav-item-dropdown>
            </template>
            <b-nav-item to="/me">
                <template v-if="auth_check">
                    <font-awesome-icon icon="user" class="fa-fw" />
                </template>
                <template v-else>
                    {{ trans.pages['login'] }}
                </template>
            </b-nav-item>
        </b-navbar-nav>
-->
    </b-navbar>
</div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    computed: {
        ...mapGetters([
            'env',
            'auth_level',
            'auth_check',
            'trans',
        ])
    },
    methods: {
        logout () {
            this.$store.dispatch('auth/logout')
        },
        login () {
            this.$store.dispatch('auth/login')
        },
    },
}
</script>
